const environment = {
    serverUrl: import.meta.env.VITE_WEB_URL!,
    servicesApiUrl: import.meta.env.VITE_SERVICES_API_URL!,
    hubUrl: import.meta.env.VITE_HUB_URL!,
    environment: import.meta.env.VITE_ENVIRONMENT!,
    version: import.meta.env.VITE_VERSION!,
    localizationApiKey: import.meta.env.VITE_LOCALIZATION_KEY || undefined,
    enableSentry: import.meta.env.VITE_ENABLE_SENTRY === "true",
    userPoolRegion: import.meta.env.VITE_AWS_REGION,
    spiffRegion: import.meta.env.VITE_SPIFF_REGION,
    userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
};
export default environment;
